import { css, styled } from '@mui/material';

import { keyValuePairItemClasses, KeyValuePairSize } from '../KeyValuePairItem';
import { keyValuePairsContainerClasses } from './theme';
import { getGridTemplateColumns } from './utils';

import type { KeyValuePairsContainerOwnerState, KeyValuePairsContainerProps } from './types';

const KeyValuePairsContainer = (props: KeyValuePairsContainerProps) => {
  const {
    labelPosition = 'left', // 기본값 설정 (theme defaultProps에서 이동)
    separateColumns = false,
    minColumnWidth = KeyValuePairSize.COLUMN_MIN_WIDTH, // 기본값 설정 (theme defaultProps에서 이동)
    maxColumnRepeat = 2, // 기본값 설정 (theme defaultProps에서 이동)
    showDivider = false,
    children,
    ...others
  } = props;

  const ownerState: KeyValuePairsContainerOwnerState = {
    ...props,
    labelPosition,
    separateColumns,
    minColumnWidth,
    maxColumnRepeat,
    showDivider,
  };

  return (
    <KeyValuePairsContainerRoot ownerState={ownerState} {...others}>
      {children}
    </KeyValuePairsContainerRoot>
  );
};

export default KeyValuePairsContainer;

const KeyValuePairsContainerRoot = styled('div', {
  target: keyValuePairsContainerClasses.root,
})<{ ownerState: KeyValuePairsContainerOwnerState }>(({ theme, ownerState }) => {
  const { minColumnWidth, maxColumnRepeat, labelPosition, showDivider, separateColumns } =
    ownerState;
  const columnTemplate = getGridTemplateColumns(minColumnWidth, maxColumnRepeat);

  const labelPositionTopStyles = css`
    grid-row-gap: ${KeyValuePairSize.ROW_GAP}px;
  `;

  const columnBorderStyle = css`
    // NOTE(@ria-ang): column-gap으로 부여한 갭 간격에서 border가 끊기지 않도록 가상 요소 추가
    & .${keyValuePairItemClasses.root} {
      position: relative;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: calc(-${KeyValuePairSize.COLUMN_GAP / 2}px);
        right: calc(-${KeyValuePairSize.COLUMN_GAP / 2}px);
        height: 1px;
        pointer-events: none;
        background: ${theme.color['border/weaker/default']};
      }
    }
  `;

  const columnBorderSeparatetyles = css`
    & .${keyValuePairItemClasses.root} {
      box-shadow: 0 -1px 0 ${theme.color['border/weaker/default']};
      border-bottom: 1px solid ${theme.color['border/weaker/default']};
    }
  `;

  return css`
    position: relative;
    overflow: hidden;

    display: grid;
    grid-column-gap: ${KeyValuePairSize.COLUMN_GAP}px;
    grid-template-columns: ${`repeat(auto-fit, ${columnTemplate})`};

    ${labelPosition === 'top' && labelPositionTopStyles}
    ${showDivider && !separateColumns && columnBorderStyle}
    ${showDivider && separateColumns && columnBorderSeparatetyles}
  `;
});
